import { render, staticRenderFns } from "./decoration-print.vue?vue&type=template&id=19c23840&scoped=true&"
import script from "./decoration-print.vue?vue&type=script&lang=js&"
export * from "./decoration-print.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c23840",
  null
  
)

export default component.exports